import { Button, styled } from "@mui/material";
import React from "react";

const StyledButton = styled(({ children, ...props }) => (
  <Button {...props}>{children}</Button>
))({
  boxSizing: "border-box",
  color: "#050D2E",
  fontSize: "14px",
  lineHeight: "16px",
  textAlign: "center",
  textTransform: "none",
  ":hover": { background: "transparent" },
});

const TextButton = ({ children, ...props }) => {
  return (
    <StyledButton {...props} variant="text">
      {children}
    </StyledButton>
  );
};

export default TextButton;
